import { Backdrop, CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { useContext } from "react";
import { FormContext } from "./context/FormProvider";
import FormButtons from "./FormBtns";
import AdditionalInformation from "./Slides/AdditionalInformation";
import BillingInformation from "./Slides/BillingInformation";
import DustServices from "./Slides/DustServices";
import GCInformation from "./Slides/GCInformation";
import GeneralInfo from "./Slides/GeneralInfo";
import IntroSlide from "./Slides/IntroSlide";
import OwnerInformation from "./Slides/OwnerInformation";
import ProjectContacts from "./Slides/ProjectContacts";
import ProjectInformation from "./Slides/ProjectInformation";
import ProjectLocation from "./Slides/ProjectLocation";
import SafetyServices from "./Slides/SafetyServices";
import SWPPPServices from "./Slides/SWPPPServices";
import "./styles/form-container.css";

const Slides = ({
  slideStatus,
  setSlideStatus,
  formState,
  formStateLoaded,
}) => {
  const { pageNumber, openBackdrop } = useContext(FormContext);
  const slides = {
    0: <IntroSlide setSlideStatus={setSlideStatus} />,
    1: (
      <GeneralInfo
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide1"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    2: (
      <SafetyServices
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide2"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    3: (
      <SWPPPServices
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide3"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    4: (
      <DustServices
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide4"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    5: (
      <OwnerInformation
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide5"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    6: (
      <GCInformation
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide6"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    7: (
      <ProjectContacts
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide7"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    8: (
      <ProjectInformation
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide8"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    9: (
      <ProjectLocation
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide9"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    10: (
      <BillingInformation
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide10"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
    11: (
      <AdditionalInformation
        setSlideStatus={setSlideStatus}
        slideState={formStateLoaded ? formState["slide11"] : null}
        formStateLoaded={formStateLoaded}
      />
    ),
  };

  const slideName = {
    0: "Argus Service Request Form",
    1: "General Information",
    2: "Safety Consulting",
    3: "SWPPP Services",
    4: "Air Quality Services",
    5: "Owner Information",
    6: "Operator Information",
    7: "Project Contacts",
    8: "Project Details",
    9: "Project Location",
    10: "Billing Information",
    11: "Submit",
  };

  const optionalParagraphs = {
    0: (
      <p className="form-container-p" id="intro-p">
        Please answer the following questions as thoroughly as possible. Some
        fields in this form are required for completion and will be surrounded
        by a red outline. Optional fields will not have a surrounding outline.
        You will be unable to submit the form until all required fields are
        complete.
      </p>
    ),
    1: (
      <p className="form-container-p" id="general-info-p">
        <strong id="general-info-bold">
          In order to save this slide, you must add the project name and click
          the next button.
        </strong>{" "}
        <br />
        All other slides will save automatically when completing a question.
      </p>
    ),
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
    9: null,
    10: null,
    11: null,
  };
  return (
    <Box
      component={"form"}
      className={`form-slide-${pageNumber}`}
      id="form-container"
      onSubmit={(e) => e.preventDefault()}
    >
      <Backdrop
        // open={true}
        open={openBackdrop}
        style={{
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <h2 id="backdrop-text">Uploading File, Please Wait...</h2>
        <CircularProgress id="backdrop-progress" size={45} />
      </Backdrop>
      <header className="form-container-header">
        <h1 className="form-container-heading">{slideName[pageNumber]}</h1>
      </header>
      {optionalParagraphs[pageNumber]}
      <div className={`form-slides`} id={`slide${pageNumber}`}>
        {slides[pageNumber]}
      </div>

      <FormButtons slideStatus={slideStatus} />
    </Box>
  );
};

export default Slides;
